export function validateUnderlyingPriceTrail(amount) {
  if (amount <= 0)
    return [false, 'Underlying price trail amount must be larger than 0.'];
  return [true, ''];
}
